import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_URL } from "./data";

const LINKS = [
  { id: "leistungen", label: "Leistungen" },
  { id: "manifest", label: "Prinzip" },
  { id: "referenzen", label: "Einblicke" },
  { id: "kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <motion.header
        data-testid="site-navbar"
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
        className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
          scrolled
            ? "bg-[#0d0d0f]/70 backdrop-blur-xl border-b border-white/10"
            : "bg-transparent border-b border-transparent"
        }`}
      >
        <nav className="mx-auto max-w-[1400px] px-6 lg:px-10 h-20 flex items-center justify-between">
          <button
            data-testid="nav-logo"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-3 group"
          >
            <img src={LOGO_URL} alt="Suisse Precision Cleaning" className="h-9 w-9 object-contain" />
            <span className="hidden sm:flex flex-col leading-none text-left">
              <span className="font-head text-[13px] tracking-[0.32em] text-metal">SUISSE PRECISION</span>
              <span className="font-mono-spc text-[9px] tracking-[0.42em] text-[#c0c5ce]/60 mt-1">CLEANING · CH</span>
            </span>
          </button>

          <div className="hidden md:flex items-center gap-10">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="font-mono-spc text-[11px] tracking-[0.22em] uppercase text-[#c0c5ce]/70 hover:text-[#4fd1c5] transition-colors duration-300"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-cta"
              onClick={() => go("kontakt")}
              className="font-mono-spc text-[11px] tracking-[0.22em] uppercase border border-[#4fd1c5] text-[#4fd1c5] px-5 py-2.5 rounded-sm hover:bg-[#4fd1c5] hover:text-[#0d0d0f] transition-colors duration-300"
            >
              Offerte
            </button>
          </div>

          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden flex flex-col gap-1.5 p-2"
            aria-label="Menü"
          >
            <span className={`block h-px w-6 bg-white transition-transform duration-300 ${open ? "translate-y-2 rotate-45" : ""}`} />
            <span className={`block h-px w-6 bg-white transition-opacity duration-300 ${open ? "opacity-0" : ""}`} />
            <span className={`block h-px w-6 bg-white transition-transform duration-300 ${open ? "-translate-y-2 -rotate-45" : ""}`} />
          </button>
        </nav>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-[#0d0d0f]/97 backdrop-blur-xl md:hidden flex flex-col items-start justify-center gap-8 px-10"
          >
            {LINKS.map((l, i) => (
              <motion.button
                key={l.id}
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.08 * i }}
                onClick={() => go(l.id)}
                className="font-head text-4xl font-light text-metal"
              >
                {l.label}
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
